export var EField;
(function (EField) {
    EField["Retroactivity"] = "retroactivity";
    EField["GenerateLetter"] = "generateLetter";
    EField["LetterType"] = "letterType";
    EField["ForceFullIndexation"] = "forceFullIndexation";
})(EField || (EField = {}));
